import React, { useState, useEffect } from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';

function PopupCommnetFooter({
  comment, onSaveComment, onCancelComment, saveRec, followUp
}) {
  return (
    <div className="align-center mt-3">
      <button
        data-id={`${ATC.PACKETID}COMMENT_SAVE${ATC.BUTTON}`}
        type="button"
        className="btn turquoise mr-2"
        onClick={() => {
          onSaveComment(comment, saveRec, followUp);
        }}
      >
        Save
      </button>
      <button
        data-id={`${ATC.PACKETID}COMMENT_CLOSE${ATC.BUTTON}`}
        type="button"
        className="btn Modal-close"
        onClick={onCancelComment}
      >
        Close
      </button>
    </div>
  );
}

function ExternalComment({
  text, onCancelComment, onSaveComment, saveRec, followUp
}) {
  const [comment, setComment] = useState(null);

  useEffect(() => {
    setComment(text);
  }, [text]);

  const onChangeComment = (e) => {
    setComment(e.target.value);
  };

  return (
    <>
      <div className="mt-3">
        <span className="font-bold">Comment:</span>
        <div className="mt-2">
          <textarea
            data-id={`${ATC.PACKETID}SUPPORTING_DOC_COMMENT${ATC.TEXTAREA}`}
            type="text"
            name="comment"
            className="form-control bg-transparent"
            value={comment}
            onChange={onChangeComment}
            placeholder=""
          />
        </div>
      </div>
      <PopupCommnetFooter
        saveRec={saveRec}
        comment={comment}
        followUp={followUp}
        onCancelComment={onCancelComment}
        onSaveComment={onSaveComment}
      />
    </>
  );
}

export default ExternalComment;
